export enum CategoryVehicleModel {
  CAR = 'CAR', // Carro

  TRUCK = 'TRUCK', // Caminhão

  FORKLIFT = 'FORKLIFT', // Empilhadeira

  EQUIPMENT = 'EQUIPMENT', // Equipamento

  IMPLEMENT = 'IMPLEMENT', // Implemento

  BAIT = 'BAIT', // Isca

  MACHINE = 'MACHINE', // Máquina

  MOTORCYCLE = 'MOTORCYCLE', // Moto

  ON_CHASSIS = 'ON_CHASSIS', // Caminhões sobre-chassis
}
